"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDateString = void 0;
var fecha_1 = __importDefault(require("fecha"));
var formatDateString = function (dateString, toFormat, fromFormat) {
  if (toFormat === void 0) {
    toFormat = 'DD/MM/YYYY';
  }
  if (fromFormat === void 0) {
    fromFormat = 'YYYY-MM-DD';
  }
  if (!dateString) {
    return '';
  }
  var parsed = fecha_1.default.parse(dateString, fromFormat);
  return parsed ? fecha_1.default.format(parsed, toFormat) : dateString;
};
exports.formatDateString = formatDateString;